export default __webpack_public_path__ + "static/media/urlShort_logo.02ca6999.png";